import Typograf from 'typograf';

const supportedLocales = Typograf.getLocales();

export function useTypograf() {
  const { locale } = useI18n();
  const { $tp } = useNuxtApp();

  const params = computed(() => {
    return supportedLocales.includes(locale.value)
      ? { locale: locale.value }
      : {};
  });

  const execute = (text) => {
    return $tp(text, params.value);
  };

  return { tp: execute };
}
